import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=2051b559&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2051b559",
  null
  
)

component.options.__file = "Users.vue"
export default component.exports